import { strLang } from "./strLang";

export const checkDay = (theDate) => {
  let day = new Date(theDate).getDay();
  return strLang("daysName")[day < 6 ? day + 1 : 0];
};
